import type { FaireProductEntity } from "../../entity_types/product";

export const p_xfyv4mrk67: FaireProductEntity = {
  token: "p_xfyv4mrk67",
  type: "product",
  name: "Organic Dark Chocolate Dipped Dried Pineapple, 26.5 LB bulk",
  brandToken: "b_3suuhjvzxi",
  brandName: "Mavuno Harvest Organics",
  imageUrl: "https://cdn.faire.com/fastly/8e1ca982b0b9e45f9a263743bc39c63ef83c64930600ebdad80fbb425414f137.png",
  galleryImageUrls: [],
  priceDollars: 335.13,
  description: "Now available in bulk 26.5 lb (12kg) cases!\n\nTart Meets Decadent\n\nTangy, golden pineapple slices meet a velvety layer of dark chocolate. The combination is tropical, bold, and just indulgent enough to satisfy your sweet tooth.\n\nIngredients\n\n•\tOrganic dried pineapple\n•\tOrganic dark chocolate\n•\tNo preservatives\n•\tNo artificial flavors\n\nWhy It Matters\n\nMade with pineapple from small farms in Ghana and organic dark chocolate sourced responsibly, this snack is a delicious way to enjoy fair, sustainable ingredients.",
  tags: [],
  msrpDollars: 623.53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:41.644Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
